var _path, _path2, _path3, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCorrectResult(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 1C9.95 1 1 9.95 1 21C1 32.05 9.95 41 21 41C32.05 41 41 32.05 41 21C41 9.95 32.05 1 21 1Z",
    fill: "#00E88F",
    stroke: "#00E88F",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4714 25.9162L14.7909 21.963C14.5557 21.7104 14.1602 21.6963 13.9076 21.9315C13.655 22.1667 13.6409 22.5622 13.8761 22.8148L17.709 26.9317C18.1011 27.3528 18.7602 27.3763 19.1812 26.9843L19.2338 26.9317L29.7909 15.5926C30.0261 15.3399 30.012 14.9445 29.7594 14.7093C29.5068 14.474 29.1113 14.4882 28.8761 14.7408L18.4714 25.9162Z",
    fill: "#616161"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1441_271696",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 14,
    width: 17,
    height: 14
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4714 25.9162L14.7909 21.963C14.5557 21.7104 14.1602 21.6963 13.9076 21.9315C13.655 22.1667 13.6409 22.5622 13.8761 22.8148L17.709 26.9317C18.1011 27.3528 18.7602 27.3763 19.1812 26.9843L19.2338 26.9317L29.7909 15.5926C30.0261 15.3399 30.012 14.9445 29.7594 14.7093C29.5068 14.474 29.1113 14.4882 28.8761 14.7408L18.4714 25.9162Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1441_271696)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 11,
    width: 20,
    height: 20,
    fill: "#333333"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorrectResult);
export default __webpack_public_path__ + "static/media/Correct-result.34f59d62bc8ceebd514151bd8b770a44.svg";
export { ForwardRef as ReactComponent };